import { cn } from '@/lib/utils';
import { Popover, PopoverContent, PopoverTrigger } from '@chiroup/components/ui/popover';
import React from 'react';

type Props = {
  clickableElement: React.ReactNode;
  options: {
    text: string;
    icon?: React.ReactNode;
    onClick: () => void;
    disabled?: boolean;
    iconOnClick?: (val: number) => void;
    id?: number;
  }[];
  disabled?: boolean;
  maxWidth?: string;
  displayLeft?: boolean;
  className?: string;
  buttonClassName?: string;
  textThenIcon?: boolean;
  keepOpen?: boolean;
};

const Dropdown: React.FC<Props> = ({
  clickableElement,
  options,
  disabled = false,
  maxWidth,
  displayLeft,
  className = '',
  buttonClassName = '',
  textThenIcon = false,
  keepOpen = false,
}) => {
  const [open, setOpen] = React.useState(false);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild disabled={disabled}>
        <div
          className={cn(
            'relative inline-block text-left',
            disabled ? 'cursor-not-allowed' : 'cursor-pointer',
            className
          )}
        >
          <div className={cn('relative inline-block text-left', buttonClassName)}>
            {clickableElement}
          </div>
        </div>
      </PopoverTrigger>
      <PopoverContent
        className={cn('w-56 p-0 z-50', maxWidth || '', displayLeft ? 'mr-auto' : 'ml-auto')}
        align={displayLeft ? 'start' : 'end'}
        side="bottom"
        sideOffset={8}
      >
        <div className="px-1 py-1">
          {options.map(
            (option, i) =>
              !option.disabled && (
                <div
                  key={i}
                  className={cn(
                    'group flex items-center px-4 py-2 text-sm leading-5 text-gray-800 dark:text-dark-gray-50 hover:bg-gray-100 dark:hover:bg-dark-gray-900 hover:text-gray-900 dark:hover:text-dark-gray-50 focus:outline-none focus:bg-gray-100 focus:text-gray-900 dark:focus:bg-dark-gray-900 dark:focus:text-dark-gray-50 rounded-sm',
                    disabled ? 'cursor-not-allowed' : 'cursor-pointer'
                  )}
                  role="menuitem"
                  onClick={() => {
                    if (!disabled) {
                      option.onClick();

                      if (!keepOpen) {
                        setOpen(false);
                      }
                    }
                  }}
                >
                  {textThenIcon ? (
                    <>
                      {option.text}{' '}
                      {option.icon && (
                        <div
                          onClick={e => {
                            e.stopPropagation();
                            option?.iconOnClick?.(option?.id || -1);
                          }}
                        >
                          {option.icon}
                        </div>
                      )}
                    </>
                  ) : (
                    <>
                      {option.icon} {option.text}
                    </>
                  )}
                </div>
              )
          )}
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default Dropdown;
